module.exports = __webpack_public_path__ + "media/bootstrap-icons/bezier2-42bedf3f.svg";